import dateFormat from 'dateformat';
import moment from 'moment';
import React from 'react';
import { UserProfession } from '../../enums/UserProfession';
import '../../themes/modalWindow.scss';

const ModalJobEdit = ({
  job_detail: jobDetail,
  editRate,
  editOfferStartTime,
  editOfferEndTime,
  editOfferDate,
  editIsLunchBreakPaid,
  editLunchBreakTime,
  editIsAssistedHygiene,
  editSkills,
  editAutoFill,
  editAutoFillFavorites,
  editAutoFillHighlyRated,
  isOnsiteInterview,
  onSave,
  closeModal,
  procedures,
}) => (
  <div className='popup'>
    <div className="popup_content">
      <div className="modal_title">
        <p>Are you sure?</p>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '100%', marginRight: '10px' }}>
          <p className="title_column">Before the update</p>
          <div className="modal_column">
            <p className="modal_text">Date</p>
            <p>{jobDetail?.local_date || ''}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Time</p>
            <p>{`${jobDetail.local_start_time} - ${jobDetail.local_end_time}`}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Rate</p>
            <p>{Number.isInteger(jobDetail.rate) ? jobDetail.rate?.toFixed(2) : jobDetail.rate}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Meal Break Paid</p>
            <p>{jobDetail.is_lunch_break_paid ? 'Yes' : 'No'}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Meal Break Time</p>
            <p>{jobDetail.lunch_break_time}</p>
          </div>
          {jobDetail?.profession === UserProfession.RDH && (
            <div className="modal_column">
              <p className="modal_text">Assisted Hygiene Available</p>
              <p>{jobDetail.isAssistedHygiene ? 'Yes' : 'No'}</p>
            </div>
          )}
          <div className="modal_column">
            <p className="modal_text">Auto-Confirm (Favorites)</p>
            {isOnsiteInterview ? (
              <p className="modal_text">-</p>
            ) : (
              <p>{jobDetail.autofillOptions?.favorite ? 'On' : 'Off'}</p>
            )}
          </div>
          <div className="modal_column">
            <p className="modal_text">Auto-Confirm (Highly-Rated)</p>
            {isOnsiteInterview ? (
              <p className="modal_text">-</p>
            ) : (
              <p>{jobDetail.autofillOptions?.highlyRated ? 'On' : 'Off'}</p>
            )}
          </div>
          <div className="modal_column">
            <p className="modal_text">Auto-Confirm (All Eligible)</p>
            {isOnsiteInterview ? (
              <p className="modal_text">-</p>
            ) : (
              <p>{jobDetail.autoFill ? 'On' : 'Off'}</p>
            )}
          </div>
          <div className="modal_column">
            <p className="modal_text">Skills</p>
            <p>{jobDetail.specialty?.split('_')?.[1] || '-'}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">{isOnsiteInterview ? 'Interview Procedure' : 'Shift Procedure'}</p>
            <p>
              {jobDetail.procedures?.length > 0
                ? jobDetail.procedures
                  .map((procedure) => procedure.replace(/^procedure_/g, ' '))
                  .join(', ')
                : '-'}
            </p>
          </div>
        </div>
        <div style={{ width: '100%' }}>
          <p className="title_column">Updated</p>
          <div className="modal_column">
            <p className="modal_text">Date</p>
            <p>{dateFormat(editOfferDate, 'ddd, mmmm dd, yyyy')}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Time</p>
            <p>
              {`${moment(editOfferStartTime, 'hh:mm A').format('hh:mm a')} - ${moment(
                editOfferEndTime,
                'hh:mm A',
              ).format('hh:mm a')}`}
            </p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Rate</p>
            <p className="modal_text">
              {Number.isInteger(editRate) ? editRate?.toFixed(2) : editRate}
            </p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Meal Break Paid</p>
            <p>{editIsLunchBreakPaid}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Meal Break Time</p>
            <p>{editLunchBreakTime}</p>
          </div>
          {jobDetail?.profession === UserProfession.RDH && (
            <div className="modal_column">
              <p className="modal_text">Assisted Hygiene Available</p>
              <p>{editIsAssistedHygiene}</p>
            </div>
          )}
          <div className="modal_column">
            <p className="modal_text">Auto-Confirm (Favorites)</p>
            <p>{isOnsiteInterview ? '-' : editAutoFillFavorites}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Auto-Confirm (Highly-Rated)</p>
            <p>{isOnsiteInterview ? '-' : editAutoFillHighlyRated}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Auto-Confirm (All Eligible)</p>
            <p>{isOnsiteInterview ? '-' : editAutoFill}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">Skills</p>
            <p>{editSkills?.split('_')?.[1] || '-'}</p>
          </div>
          <div className="modal_column">
            <p className="modal_text">{isOnsiteInterview ? 'Interview Procedure' : 'Shift Procedure'}</p>
            <p>
              {procedures?.length > 0
                ? procedures.map((procedure) => procedure.replace(/^procedure_/g, ' ')).join(', ')
                : '-'}
            </p>
          </div>
        </div>
      </div>

      <div className="modal_button">
        <button type="button" className="cancel" onClick={() => closeModal()}>
          Cancel
        </button>
        <button type="button" className="confirm" onClick={onSave}>
          Confirm
        </button>
      </div>
    </div>
  </div>
);

export default ModalJobEdit;
